
import { defineComponent, ref, computed, getCurrentInstance } from 'vue'
import { PriceExplanationBenefit } from '@alao-frontend/core'
import OfferCardDiscountLabel from '~/components/offers/NewOfferCard/OfferCardDiscountLabel.vue'
import OfferCardExclusiveLabel from '~/components/offers/NewOfferCard/OfferCardExclusiveLabel.vue'
import PriceExplanation from '~/components/offers/PriceExplanation.vue'
import IconInfo from '~/assets/icons/icon-info.svg?inline'
import AppTooltip, { TooltipTrigger } from '~/components/AppTooltip.vue'

export default defineComponent({
  name: 'OfferCardPrice',
  components: {
    OfferCardDiscountLabel,
    OfferCardExclusiveLabel,
    PriceExplanation,
    IconInfo,
    AppTooltip,
  },
  props: {
    regularPrice: { type: Number, default: 0 },
    finalPrice: { type: Number, required: true, default: 0 },
    priceDiscountLabel: { type: String, default: '' },
    effectivePercent: { type: Number, required: true, default: 0 },
    effectivePrice: { type: Number, required: true, default: 0 },
    discountDaysLeft: { type: Number, required: true, default: 0 },
    contractDuration: { type: Number, required: true, default: 0 },
    savings: { type: Number, required: true, default: 0 },
    benefits: { type: Array as () => PriceExplanationBenefit[], required: true, default: () => [] },
    progressBar: { type: Number, default: 0 },
    endDateInFewDays: { type: String, default: null },
    isAlaoExclusiveOffer: { type: Boolean, default: false },
    pricesTooltipTrigger: { type: String as () => TooltipTrigger, default: 'hover' },
    showDiscountLabel: { type: Boolean, default: true },
    priceExplanation: { type: Boolean, default: true },
  },
  setup (props) {
    const app = getCurrentInstance()
    const isPriceExplanationVisible = ref(false)

    function toggleIsPriceExplanationVisible (force?: boolean) {
      isPriceExplanationVisible.value = force ?? !isPriceExplanationVisible.value
    }
    const device = computed(() => {
      return app?.proxy.$device
    })
    const handlePriceClick = () => {
      if (!device.value?.isTouch) {
        return
      }
      toggleIsPriceExplanationVisible()
    }

    const isShowPriceExplanation = computed(() =>
      !!props.benefits.length && props.priceExplanation,
    )

    return {
      isPriceExplanationVisible,
      toggleIsPriceExplanationVisible,
      handlePriceClick,
      isShowPriceExplanation,
      ...props,
    }
  },
})
